import React, {useContext} from 'react'
import {Button, Popconfirm} from "antd";
import {RecipeConText} from "../../../../../context/RecipeContext";

const RecipeProductionDelete = ({rowId}) => {

    const {productionData} = useContext(RecipeConText)
    const [productionCosts, setProductionCosts] = productionData



    const handleDeleteClick = () => {
        let mockRows = Object.assign({}, productionCosts)
        delete mockRows[rowId]

        setProductionCosts(mockRows)
    }

    return(
        <React.Fragment>
            <Popconfirm
                title={'Silmek istediğinize emin misiniz ?'}
                okText={'SİL'}
                cancelText={'VAZGEÇ'}
                okButtonProps={{type: 'danger'}}
                onConfirm={handleDeleteClick}
            >
                <Button
                    type={'link'}
                    danger
                >
                    Sil
                </Button>
            </Popconfirm>
        </React.Fragment>
    )
}
export default RecipeProductionDelete